import { IconButton } from '@aibees/shared/components';
import { SHARED_ROUTES } from '@aibees/shared/constants';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportTableViewRecordsActionProps as Props } from './types';

export const ExportTableViewRecordsAction = memo(
  ({ className, item }: Props) => {
    const handleViewClick = () => {
      window.open(`${SHARED_ROUTES.searchListExport}/${item.id}`, '_blank');
    };

    return (
      <Styled.Wrapper
        className={classnames('ExportTableViewRecordsAction', className)}
        sx={SX.root}
      >
        <IconButton
          icon="eye-outlined"
          variant="outlined"
          size="xsmall"
          onClick={handleViewClick}
        />
      </Styled.Wrapper>
    );
  }
);

ExportTableViewRecordsAction.displayName = 'ExportTableViewRecordsAction';
